<template>

  <!-- 1st Hero Variation -->
  <section class="custom_page funnel_page" style="">


      <card type="secondary" style="" shadow  v-if="is_load"
            header-classes="bg-white pb-5"
            body-classes=""
            class="border-0 funnel_card">
      <div class="row">

        <div class=" col-lg-12">
          <h2> {{ funnel.title}}</h2>
          <vue-suggestion placeholder="Введите запрос для поиска" inputClasses="form-control" :items="items"
                          v-model="item"
                          :setLabel="setLabel"
                          :itemTemplate="itemTemplate"
                          @changed="inputChange"
                          @selected="itemSelected">
          </vue-suggestion>

          <div class="row" v-if="stages.length>0">
            <div class="col-lg-12 m-4">
              <p><a href="#" @click="callModalAddLead()" class="btn side4">Добавить лид</a></p>
            </div>
            <kanban-board  @update-block="updateBlock" :stages="stages" :blocks="blocks"> <div v-for="stage in stages" :slot="stage" :key="stage" >
              <h2>{{ stage }}</h2>
            </div>

              <sui-card class="lead_mini" style="" v-for="block in blocks" :slot="block.id" :key="block.id" >

                <sui-card-content class="lead_info ">
                  <sui-card-header @click="openLead(block.id)" >#{{ block.lead.id }}</sui-card-header>
                  <sui-card-header @click="openLead(block.id)"  v-if="block.lead.lead_data.name && block.lead.lead_data.name.length>0">{{ block.lead.lead_data.name}}</sui-card-header>
                  <sui-card-meta @click="openLead(block.id)" v-if="block.lead.lead_data.email && block.lead.lead_data.email.length>0"><sui-icon name="address book"/>{{ block.lead.lead_data.email }}</sui-card-meta>
                  <sui-card-meta @click="openLead(block.id)" v-if="block.lead.lead_data.phone && block.lead.lead_data.phone.length>0"><sui-icon name="phone square" /> {{ block.lead.lead_data.phone }}</sui-card-meta>

                  <sui-card-description @click="openLead(block.id)" v-if="block.lead.tags && block.lead.tags.length>0"
                  ><b v-for="(tag,tag_index) in block.lead.tags" :key="tag_index">#{{tag}}&nbsp;</b></sui-card-description
                  >
                  <sui-card-meta>
                    <button class="btn side4" @click="callModelEditLead(block.lead)">Открыть заявку</button>
                  </sui-card-meta>
                </sui-card-content>

              </sui-card>
             </kanban-board>
          </div>
        </div>

      </div>
    </card>
  </section>

</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Api from "../models/Api";
import Modal from "@/components/Modal";
import CircleChart from "@/models/CircleChart";

import vueKanban from 'vue-kanban';
import itemTemplate from '@/components/itemTemplate.vue';

export default {
  name: "home",

  data() {

    var app = this;

    return {
      "is_load":false,
      stages: [],
      current_funnel:null,
      statuses:[],
      funnel:null,
      blocks: [

      ],
      "funnels": {},
      item: {},
      items: [

      ],
      itemTemplate,


    }
  },

  mounted: function () {

    var app = this;
    let id = app.$route.params.id;
    app.current_funnel=id;

    Api.loadFunnel(id,function(data){
      app.is_load=true;
      app.funnel=data.funnel;

      if(data.statuses.length>0){
        app.statuses=data.statuses;
        var statuses=data.statuses;
        statuses.forEach((element) => {
          app.stages.push(element.title);
        })
        statuses.forEach((element) => {
          if(element.leads && element.leads.length>0){
            var leads=element.leads;

            leads.forEach((lead) => {

              var new_arr={
                id: lead.id,
                status: element.title,
                title: 'Лид '+lead.id,
                lead:lead,
              }
              app.blocks.push(new_arr);
            })
          }
        })

      }
    })





  },
  methods: {
    callModelEditLead(lead){
      var app=this;
      var params = {
        "lead_id": lead.id,
        type: "editlead",
        modal_title: "Редактирование лида",
        json:lead.project_data
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },
    updateBlock(id, status) {
      var app=this;

      var statuses=app.statuses;
      var new_status=null;
      statuses.forEach((element) => {
        if(element.title==status){
          new_status=element;
        }

      })
      if(new_status!=null){
        var app=this;
        var lead_id=id;

        var  json={

          "status_id":new_status.last_id,

        }

        Api.updateLead(json,lead_id,function(data){

        },function(error){
          alert(error);
        });
      }

      //this.blocks.find(b => b.id === Number(id)).status = status;
    },
    openLead(lead_id){
      var app=this;
      app.$router.push({name: 'lead', params: {id: lead_id, "rand": Math.random()}});
    },
    itemSelected (item) {
      this.item = item;
      var app=this;
      app.$router.push({name: 'lead', params: {id: item.id, "rand": Math.random()}});
    },
    setLabel (item) {
      return item.name;
    },
    inputChange (text) {
      var app=this;
      // your search method
      app.items=[];
      Api.searchLead(text,function(data){
        if(data.leads.length>0){
      var leads=data.leads;

          leads.forEach((element) => {
            var name="";
            if(element.lead_data.name){
              name=name+" "+element.lead_data.name;
            }
            if(element.lead_data.phone){
              name=name+" "+element.lead_data.phone;
            }
            if(element.lead_data.email){
              name=name+" "+element.lead_data.email;
            }
            name=name+" "+element.funnel.title+"/"+element.status.title;
            var new_element={id:element.id,name:name};
            app.items.push(new_element);
          })
        }
      });
      // now `items` will be showed in the suggestion list
    },
    callModalAddLead() {

      var app=this;

      var params = {

        type: "addlead",
        islead: true,
        funnel_id:app.current_funnel,

        modal_title: "Добавление лида",

        json: {
          "blocks": [{
            "type": "header",
            "data": {
              "text": "Безымянный проект",
              "level": 2
            }
          }]
        }
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },


  },
  components: {Modal}
};
</script>
